import axios from 'axios'

import { ERR_CODES } from '@/shared/constant/errcodes'
import {
  APP_WCRS_DEV,
  APP_WCRS_PROD,
  IMAGE_SERVER_DEV,
  IMAGE_SERVER_PROD,
} from '@/shared/constant/url'
import { guid } from '@/shared/utils'
import { captureServerError, captureUnexpectedErrCode } from '@/shared/utils/sentry/api'
import { addApiBreadcrumb } from '@/shared/utils/sentry/breadcrumb'

export const hostServer = () => {
  if (
    window.location.host.includes('dev') ||
    window.location.host.includes('local') ||
    window.location.host.includes('5.0.50')
  ) {
    return APP_WCRS_DEV
  } else {
    return APP_WCRS_PROD
  }
}

export const hostImageServer = () => {
  if (
    window.location.host.includes('dev') ||
    window.location.host.includes('local') ||
    window.location.host.includes('5.0.50')
  ) {
    return IMAGE_SERVER_DEV
  } else {
    return IMAGE_SERVER_PROD
  }
}

export const httpData = <T>(CmdType: number, Body?: T) => {
  return JSON.stringify({
    Header: {
      CmdType,
      RequestID: guid(),
    },
    Body,
  })
}
export const axiosDefaultData = async <T>(CmdType: number, Body?: T) => {
  addApiBreadcrumb('request', { cmdType: CmdType })

  return await axios
    .post(hostServer(), httpData(CmdType, Body), { withCredentials: true })
    .then((response) => {
      const { Header, Body } = response.data
      if (Header.ErrCode !== ERR_CODES.Success) {
        addApiBreadcrumb('response', {
          cmdType: CmdType,
          errCode: Header.ErrCode,
          errMsg: Header.ErrMsg,
        })
        captureUnexpectedErrCode(Header)
      }
      return { Header, Body }
    })
    .catch((error) => {
      captureServerError(error, CmdType)
      return error
    })
}
